import { render, staticRenderFns } from "./PerguntaEditBase.vue?vue&type=template&id=784c237a"
import script from "./PerguntaEditBase.vue?vue&type=script&lang=js"
export * from "./PerguntaEditBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports